<app-nav></app-nav>
<section class="add-insurances">
  <div class="container text-center">
    <div class="refer-success">
      <h5>Referred Successfully</h5>
      <img src="assets/images/refer-success.jpg" />
      <h4>Thank You</h4>
      <!-- <p>We will reach out to your friend, if he bought any insurance policy from us, you will be rewarded with amazon
        gift voucher.</p> -->
      <div class="text-center">
        <button class="btn btn-orange mt-4 btn-padding" (click)="goBack();">Refer More</button>
      </div>
    </div>
    <div class="refer-success-bottom">
      <p>For any queries, please reach us at:</p>
      <img src="assets/images/securenow-logo.png" />
      <p>
        <span>+91 9696683999</span>
        <span>|</span>
        <span>support@securenow.in</span>
      </p>
    </div>
  </div>
</section>